export default "__VITE_ASSET__DYEdihG6__"